import { all, call, fork, put, takeLatest } from "redux-saga/effects";
import {
  fetch_device_config_failure,
  fetch_device_config_success,
  update_device_config_failure,
  update_device_config_success,
} from "actions/deviceConfig";
import {
  FETCH_DEVICE_CONFIG,
  UPDATE_DEVICE_CONFIG,
} from "constants/ActionTypes";
import config from "config";
import { deleteDatabase } from "indexedb";
import { removeCookie, deleteToken, getToken } from "../util/helpers";

async function request(options) {
  function check_status(response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }

    if (response.status === 401 && window.location.pathname !== "/app/signin") {
      return response;
    }
  }
  function parse_JSON(response) {
    if (!response || response.status === 204 || response.status === 205) {
      return null;
    }

    return response.json();
  }

  let headers = {};
  headers = {
    ...options.headers,
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: `${getToken()}`,
  };

  options = {
    ...options,
    headers,
  };

  return fetch(
    `${config.device_config_url}/${config.api_version}${options.path}`,
    options
  )
    .then(check_status)
    .then(parse_JSON)
    .then((data) => {
      if (!data) return { data: null };
      if (data.error) {
        if (data.message === "Invalid credentials") {
          localStorage.removeItem("user_id");
          sessionStorage.clear();
          removeCookie("token");
          deleteDatabase();
          deleteToken();
          window.location = "/";
        }
      }
      return data;
    });
}

function* fetch_devices_config_saga() {
  try {
    const response = yield call(request, {
      path: `/datahub/get_physician_devices_config`,
      method: "GET",
    });

    if (response.status === 200 && response.data !== null) {
      yield put(fetch_device_config_success(response.data));
    } else {
      yield put(fetch_device_config_failure());
    }
  } catch (error) {
    console.error(error);
  }
}

function* update_device_config_saga({ payload }) {
  try {
    const response = yield call(request, {
      path: `/datahub/update_device_config`,
      method: "POST",
      body: JSON.stringify(payload),
    });

    if (response.status === 200 && response.data !== null) {
      yield put(update_device_config_success());
    } else {
      yield put(update_device_config_failure());
    }
  } catch (error) {
    console.error(error);
  }
}

export function* fetch_devices_config() {
  yield takeLatest(FETCH_DEVICE_CONFIG, fetch_devices_config_saga);
}

export function* update_device_config() {
  yield takeLatest(UPDATE_DEVICE_CONFIG, update_device_config_saga);
}

export default function* rootSaga() {
  yield all([fork(fetch_devices_config), fork(update_device_config)]);
}
